import apiFetch from '../../apiFetch'

export default function (token, dossierId, notifyData) {
  return apiFetch({ endPoint: `/Dossier/DelayNonUpdatedDossierAlert/${dossierId}?notifyData=${notifyData}`, method: 'PUT', body: null, token: token })
}
